import React, { useEffect, useRef } from "react";
import { MdShoppingBasket } from "react-icons/md";
import { motion } from "framer-motion";
import NotFound from "../img/panda.svg";
import { actionType } from "./context/reducer";
import { useStateValue } from "./context/StateProvider";
import { useState } from "react";
// import { useState } from "react";
const RowContainer = ({flag,data,scrollValue}) => {
    const rowContainer = useRef();
    const [{ cartItems }, dispatch] = useStateValue();
    const [items, setItems] = useState([]);

    useEffect(()=>{
        rowContainer.current.scrollLeft += scrollValue;
    },[scrollValue])
    const addtocart = () => {
      dispatch({
        type: actionType.SET_CARTITEMS,
        cartItems: items,
      });
      localStorage.setItem("cartItems", JSON.stringify(items));
    };
    useEffect(() => {
      addtocart();
    }, [items]);
    return( <div ref={rowContainer} 
        className={`w-full flex items-center gap-3  my-12 scroll-smooth  ${
        flag
          ? "overflow-x-scroll scrollbar-none"
          : "overflow-x-hidden flex-wrap justify-center"}`}
           >

            {data && data.length > 0 ?
            (data.map((item) => (
                <div key={item?.id} className="w-275 h-[275px] min-w-[275px] md:w-300 md:min-w-[300px]  bg-cardOverlay rounded-lg py-2 px-4  my-12 backdrop-blur-lg
                hover:drop-shadow-lg flex flex-col items-center 
                justify-evenly relative">
       
                   <div className="w-full flex items-center  justify-between">
       
                   <motion.div
                className="w-40 h-40 -mt-8 drop-shadow-2xl"
                whileHover={{ scale: 1.2 }}
              >
                <img
                  src={item?.imageURL}
                  alt=""
                  className="w-full h-full object-contain"
                />
              </motion.div>
       
       
                   <motion.div whileTap={{scale : 0.75}} className="w-8 h-8  rounded-full bg-red-600 flex items-center justify-center cursor-pointer hover:shadow-md"
                      onClick={() => setItems([...cartItems, item])}
                   >
                       <MdShoppingBasket className=" text-white " /> 
       
                   </motion.div>
       
       
                   </div>
                   <div className="w-full flex flex-col items-end justify-end">
       
                       <p className="text-textColor font-semibold text-base md:text-lg">
                           {item?.title}
                       </p>
                       <p className="mt-2 text-sm text-gray-400">
                           {item?.calories} Cal
                       </p>
                       <div className="flex items-center gap-2 ">
                           <p className="text-sm font-semibold text-headingColor-400"><span className="font-semibold text-green-600">$</span> {item?.price} </p>    
                       </div> 
                   </div>
       
               </div>
            ))
            ) : (<div className="w-full flex flex-col items-center justify-center">
          <img src={NotFound} className="h-340" />
          <p className="text-xl text-headingColor font-semibold my-2">
            Items Not Available
          </p>
        </div>
            )
            }


        
    </div>
    );
};
export default RowContainer;